// extracted by mini-css-extract-plugin
export var Cover = "PageHeader-module--Cover--2c7Ft";
export var CoverContent = "PageHeader-module--CoverContent--2JUu_";
export var Content = "PageHeader-module--Content--2W_Nk";
export var BackgroundImage = "PageHeader-module--BackgroundImage--3OM2T";
export var Video = "PageHeader-module--Video--3vmSd";
export var cta = "PageHeader-module--cta--BOIVg";
export var Padding = "PageHeader-module--Padding--1vEI2";